var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ctaLink)?_c('div',{staticClass:"Component wrapper-cta",attrs:{"data-cta-align":_vm.ctaAlign}},[_c('a',{staticClass:"cta-button",attrs:{"href":_vm.ctaLink,"target":_vm.ctaTarget}},[_vm._v(_vm._s(_vm.ctaText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }